import React from 'react';
import FolderTabNav, { type FolderTabItem } from './folder-tab-nav';

interface FolderTabLayoutProps {
  tabs: FolderTabItem[];
  value: string;
  onValueChange: (value: string) => void;
  children: React.ReactNode;
  className?: string;
}

/**
 * FolderTabLayout
 *
 * The "main menu" shell: a FolderTabNav tab row fused directly into the
 * content pane below it (see FolderTabNav for the visual trick). Use for
 * top-level page menus; use SettingsSidebarLayout for a nested sub-menu
 * within one of these tabs.
 */
const FolderTabLayout: React.FC<FolderTabLayoutProps> = ({ tabs, value, onValueChange, children, className }) => (
  <div className={className}>
    <FolderTabNav tabs={tabs} value={value} onValueChange={onValueChange} />
    <div className="rounded-b-xl rounded-tr-xl border border-yellow-900/20 bg-zinc-900 p-4 sm:p-5">
      {children}
    </div>
  </div>
);

export default FolderTabLayout;
